import styled from 'styled-components';

export const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-width: 300px;
`;

export const OptionContainerRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const OptionOptionsContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: right;
  align-items: center;
  width: 95%;
  margin-top: 20px;
`;

export const OptionDataContainer = styled.div`
  text-align: left;
  max-width: 40vw;
`;

export const OptionDataTitle = styled.h4``;

export const OptionDataText = styled.p`
  margin-left: 5px;
`;